import ConfirmModal from '@/components/Shared/Modal/ConfirmModal';
import { consoleError } from '@/helpers/logger';

const ModalPlugin = {
  install: function(Vue, options) {
    const { appInstance } = options;

    if (!appInstance) {
      consoleError('appInstance parameter must be required!');
      return;
    }

    Vue.prototype.$showConfirmModal = function(props, listeners) {
      return this.$showModal(ConfirmModal, props, listeners);
    };

    Vue.prototype.$showModal = function(Component, props, listeners) {
      const instance = new Vue({ name: 'Modal', parent: appInstance, render: h => h(Component, { props, on: listeners }) }).$mount();

      const modalObject = {
        close() {
          instance.$destroy();
        },
        delayedClose() {
          setTimeout(() => {
            instance?.$destroy();
          }, 1000);
        },
      };

      if (instance.$children[0].$children[0]) {
        instance.$children[0].$children[0].$modal = modalObject;
      }
      if (instance.$children[0]) {
        instance.$children[0].$modal = modalObject;
      }

      return modalObject;
    };
  },
};

export default ModalPlugin;
